import { action, computed, makeObservable, observable } from 'mobx'
import ModalViewModel from 'infra/ModalViewModelSansDecorators'
import { JobScopeItem } from 'jobs/Job'
import { Id } from 'types/definitions'
import { GetCurrentMember } from 'iam/SessionStore'

export interface ServiceItem {
  name: string
  quantity: number
  clientPrice?: number
  proPrice?: number
  courtesyQuantity?: number
}

export default class ServiceItemListViewModel extends ModalViewModel {
  jobScopeItems: JobScopeItem[] = []

  constructor(
    jobScopeItems: JobScopeItem[],
    public workspaceId: Id,
    private getCurrentMember: GetCurrentMember,
  ) {
    super()
    makeObservable(this, {
      jobScopeItems: observable,
      canSeePriceAsAdmin: computed,
      canSeeProPayoutAsAdmin: computed,
      serviceItems: computed,
      setJobScopeItems: action.bound,
      toggleShowing: action.bound,
    })
    this.setJobScopeItems(jobScopeItems)
  }

  /**
   * Returns a list of service items.
   */
  get serviceItems(): ServiceItem[] {
    return this.jobScopeItems
      .filter((item) => item.bundle_id === null)
      .map((item) => ({
        name: item.name,
        quantity: item.quantity,
        clientPrice: item.price,
        proPrice: item.pro_price,
        courtesyQuantity: item.courtesy_quantity,
      }))
  }

  /**
   * Determines whether we can see pricing in the `ServiceItemList` modal.
   */
  get canSeePriceAsAdmin() {
    return this.getCurrentMember(this.workspaceId).hasPermission(
      'ADMIN_VIEW_PRICING',
    )
  }

  /**
   * Determines whether we can see the pro payout in the `ServiceItemList` modal.
   */
  get canSeeProPayoutAsAdmin() {
    return this.getCurrentMember(this.workspaceId).hasPermission(
      'ADMIN_PRO_CUT_VIEW',
    )
  }

  /**
   * Sets the job scope items list.
   */
  setJobScopeItems(jobScopeItems: JobScopeItem[]) {
    this.jobScopeItems = jobScopeItems
  }

  /**
   * Toggles whether the dialog is open.
   */
  toggleShowing() {
    this.showing = !this.showing
  }
}
